import i18n from "@/i18n";

export const MONTH_NAMES = [
    i18n.t('strings.MONTH_1'),
    i18n.t('strings.MONTH_2'),
    i18n.t('strings.MONTH_3'),
    i18n.t('strings.MONTH_4'),
    i18n.t('strings.MONTH_5'),
    i18n.t('strings.MONTH_6'),
    i18n.t('strings.MONTH_7'),
    i18n.t('strings.MONTH_8'),
    i18n.t('strings.MONTH_9'),
    i18n.t('strings.MONTH_10'),
    i18n.t('strings.MONTH_11'),
    i18n.t('strings.MONTH_12')
];

export const DAYS_NAMES = [
    i18n.tc('strings.WK_SUN',1),
    i18n.tc('strings.WK_MON',1),
    i18n.tc('strings.WK_TUE',1),
    i18n.tc('strings.WK_WED',1),
    i18n.tc('strings.WK_THU',1),
    i18n.tc('strings.WK_FRI',1),
    i18n.tc('strings.WK_SAT',1),
];

export const todayHowString = () => {
    let today = new Date();
    let date = {
        'month': today.getMonth() + 1,
        'year': today.getFullYear(),
        'day': today.getDate()
    };
    return `${date.year}-${date.month < 10 ? '0' + date.month : date.month}-${date.day < 10 ? '0' + date.day : date.day}`;
};
/**
 * convert '2020-01-10' --> '10 IANUARIE 2020'
 * @param date
 * @returns {string}
 */
export const dateConvert = (date) => {
    let dateArr = date.split('-').map((item) => {
        return parseInt(item)
    });
    return `${dateArr[2]} ${MONTH_NAMES[dateArr[1] - 1]} ${dateArr[0]}`
};
/**
 * convert '2020-01-10' --> 'Luni, 10 Ianuarie'
 * @param date
 * @returns {string}
 */
export const dateConvertSchedule = (date) => {
  if (date == null || date === '' || date === undefined ) {
    return '';
  }
  let dateArr = date.split('-').map((item) => {
    return parseInt(item)
  });
  return `${DAYS_NAMES[dateArr[2]%7]}, ${dateArr[2]} ${MONTH_NAMES[dateArr[1] - 1]}`
};

/**
 * convert '2020-01-10 11:00' --> Date
 * @param date
 * @returns {Date}
 */
export const dateConvertToNumber = (date) => {
  if (date == null || date === '' || date === undefined ) {
    return new Date(0, 0, 0, 0, 0, 0, 0);
  }
  let [dateStr, timeStr] = date.split(' ');
  let dateArr = dateStr.split('-').map((item) => {
    return parseInt(item)
  });
  let timeArr = timeStr.split(':').map((item) => {
    return parseInt(item)
  });
  return new Date(dateArr[0], dateArr[1] - 1, dateArr[2], timeArr[0], timeArr[1]);
};

/**
 * isSoonDate
 * @param {string} date - date in format '2020-01-10 11:00'
 * @param {number} soon - second period
 * @returns {number}
 * returns 1,0,-1 only
 * (1) date is coming soon
 * (0) date is not coming soon
 * (-1) no valid date
 */
export const isSoonDate = (date, soon) => {
  if (date == null || date === '' || date === undefined ) {
    return -1
  }
  let now = Math.trunc((new Date()).getTime() / 1000);
  let timeNum = Math.trunc(dateConvertToNumber(date).getTime() / 1000);
  if ((timeNum - now - soon) <= 0) {
    return 1
  } else {
    return 0
  }
};

export const escapeHTML = (str) => {
  return str.replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#039;");
};

export const decodeHtml = (str) => {
  var map =
    {
      '&amp;': '&',
      '&lt;': '<',
      '&gt;': '>',
      '&quot;': '"',
      '&#039;': "'"
    };
  return str.replace(/&amp;|&lt;|&gt;|&quot;|&#039;/g, function (m) {
    return map[m];
  });
};


import lStorage from '@/store/localStorage';
import env from '@/enviroment';
export const rest = {
    /**
     * Вызывает метод апи
     * @param {String} method 
     * @param {*} data 
     * @param {*} request_method 
     */
    call(method,data={},request_method="GET",with_session=true){
        if(method){
            var rest_data = Object.assign(
                with_session==true?{"session":lStorage.get('auth-token')}:{},
                data
            );
            var endpoint = env.URL+'/custom/service/v4_2/rest.php?method='+method+'&input_type=JSON&response_type=JSON&rest_data='+JSON.stringify(rest_data);
            return fetch(endpoint,{
                method:request_method
            }).then(response=>response.json());
        }
    },
};

export const cookie = {
  /**
   * Устанавливает куки
   * @param {String} method 
   * @param {*} data 
   * @param {*} request_method 
   */
  set(name, value, options = {}){
    options = {
      path: '/',
    };
  
    if (options.expires instanceof Date) {
      options.expires = options.expires.toUTCString();
    }
  
    let updatedCookie = encodeURIComponent(name) + "=" + encodeURIComponent(value);
  
    for (let optionKey in options) {
      updatedCookie += "; " + optionKey;
      let optionValue = options[optionKey];
      if (optionValue !== true) {
        updatedCookie += "=" + optionValue;
      }
    }
    document.cookie = updatedCookie;
  }
};

export const formatPrice = (value,currency)=>{
  switch(currency.toLowerCase()){
    case "eur":
    default:
      return value+" €";
    break;
    case "rub":
      return value+" ₽";
    break;
    case "usd":
      return "$ "+value;
    break;
    case "uah":
      return value+" ₴";
    break;
    case "mdl":
      return value+" LEI";
    break;
  }
  return value;
};

export const randomString = (length=6)=>{
  var result=[];
  var characters='ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  var charactersLength=characters.length;
  for(var i = 0; i < length; i++ ){
    result.push(characters.charAt(Math.floor(Math.random() * 
    charactersLength)));
  }
  return result.join('');
};